import { render, staticRenderFns } from "./ClickAndBuyVariantsForm.vue?vue&type=template&id=48ced107&scoped=true"
import script from "./ClickAndBuyVariantsForm.vue?vue&type=script&lang=js"
export * from "./ClickAndBuyVariantsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ced107",
  null
  
)

export default component.exports